import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=09a39c8f&scoped=true&"
import script from "./PanelGroup.vue?vue&type=script&lang=js&"
export * from "./PanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=09a39c8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a39c8f",
  null
  
)

export default component.exports